import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { useBongLayout } from '~Providers/BongLayout';
import CategoryButton from './CategoryButton';
const Wrapper = styled.div`
  flex: 0 0 80px;
  border-right: 1px solid var(--colorBlueGray1000);
`;

interface Props {
  clearSubpage?: () => void;
}

const Categories: FC<Props> = ({ clearSubpage }) => {
  const layout = useBongLayout();

  const handleSelect = (categoryId: string) => {
    if (clearSubpage) {
      clearSubpage();
    }

    layout.setSelectedCategoryId(categoryId);
  };

  return (
    <Wrapper>
      {layout.categories.map((category) => (
        <CategoryButton
          key={category.id}
          category={category}
          isSelected={layout.selectedCategoryId === category.id}
          onSelect={handleSelect}
        />
      ))}
    </Wrapper>
  );
};

export default memo(Categories);
